module.exports = __webpack_public_path__ + "img/logo.b4cf2ab0.svg";